import { motion } from "framer-motion";
import { Reveal, MaskLineInView } from "./Reveal";
import { IMAGES } from "@/lib/apiClient";

const days = [
  { d: "01", t: "Jesus sees you", v: "John 4:7–10" },
  { d: "02", t: "Jesus knows your story", v: "John 4:16–18" },
  { d: "03", t: "Jesus offers living water", v: "John 4:13–14" },
  { d: "04", t: "Jesus forgives & restores", v: "1 John 1:9" },
  { d: "05", t: "Jesus calls for a response", v: "Acts 2:37–38" },
  { d: "06", t: "Jesus gives a spiritual family", v: "Acts 2:42–47" },
  { d: "07", t: "Jesus sends transformed witnesses", v: "John 4:28–39" },
];

export default function ComeToWater() {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden bg-[#05030A]">
      <div className="absolute right-0 top-0 w-1/2 h-full opacity-30">
        <img src={IMAGES.dove} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#05030A] via-[#05030A]/60 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal><span className="section-label">The 7-Day Journey</span></Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02] mt-5 text-white">
            <MaskLineInView><span className="italic">"Come to the Water"</span></MaskLineInView>
          </h2>
          <Reveal delay={0.15}>
            <p className="text-lg text-[#B4ADC1] font-light mt-6 leading-relaxed max-w-xl">
              A free seven-day Bible journey. Each day: one Scripture, a short devotional, a reflection question, a prayer, one action — and a minister who will walk with you.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-14">
          {days.map((day, i) => (
            <motion.div
              key={day.d}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.07 }}
              className="glass rounded-2xl p-6 hover:border-gold/30 transition-colors duration-500"
            >
              <span className="font-display text-3xl text-gold">{day.d}</span>
              <p className="text-white font-light mt-3 leading-snug">{day.t}</p>
              <p className="font-mono text-[0.65rem] tracking-widest text-[#7A708A] mt-3 uppercase">{day.v}</p>
            </motion.div>
          ))}
          <div className="glass-gold rounded-2xl p-6 flex flex-col justify-center">
            <p className="font-display text-2xl text-white leading-tight">Begin below ↓</p>
            <p className="text-sm text-[#B4ADC1] mt-2 font-light">Request your free journey.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
